import clsx from 'clsx';
import styles from './OtherEntry.module.css';

export const EntryBreaker = () => {
  return (
    <div className={clsx(styles.entryBreaker, 'daymadeTypographySRegular')}>
      Or
    </div>
  );
};

interface EntryContentProps {
  icon?: React.ReactNode;
  iconOnSelected?: React.ReactNode;
  rightContent?: React.ReactNode;
  selected?: boolean;
  textOrange?: string;
  textSubtitle?: string;
  textTitle?: string;
}

export const EntryContent = ({
  icon,
  iconOnSelected,
  rightContent,
  selected = false,
  textOrange,
  textSubtitle,
  textTitle,
}: EntryContentProps) => {
  return (
    <div className={styles.content}>
      <div className={styles.contentLeft}>
        <div
          className={clsx(
            styles.icon,
            selected ? styles.iconSelected : styles.iconDeselected,
          )}
        >
          {icon && <span className={styles.mainIcon}>{icon}</span>}
          {iconOnSelected && (
            <span className={styles.selectedIcon}>{iconOnSelected}</span>
          )}
        </div>
        <div className={styles.contentText}>
          {textTitle && (
            <div className="daymadeTypographySBold">{textTitle}</div>
          )}
          {textSubtitle && (
            <div
              className={clsx(
                styles.entrySubtitle,
                'daymadeTypographySRegular',
              )}
            >
              {textSubtitle}
            </div>
          )}
          {textOrange && (
            <div
              className={clsx(styles.entryOrange, 'daymadeTypographySRegular')}
            >
              {textOrange}
            </div>
          )}
        </div>
      </div>
      <div>{rightContent}</div>
    </div>
  );
};

interface EntryWrapperProps {
  badge?: string;
  badgeColor?: 'teal' | 'orange';
  children: React.ReactNode;
  disableHoverEffects?: boolean;
  hideEntry?: boolean;
  onClick?: () => void;
  selected?: boolean;
}

const EntryWrapper = ({
  badge,
  badgeColor,
  children,
  disableHoverEffects,
  hideEntry,
  onClick,
  selected,
}: EntryWrapperProps) => {
  if (hideEntry) {
    return null;
  }

  return (
    <div
      onClick={onClick}
      className={clsx(
        styles.entryWrapper,
        disableHoverEffects && styles.disableHoverEffects,
        selected && styles.selected,
      )}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-pressed={onClick ? selected : undefined}
    >
      {badge && (
        <span
          className={clsx(
            styles.badge,
            badgeColor && styles['badgeBackground__' + badgeColor],
            'daymadeTypographySBold',
          )}
        >
          {badge}
        </span>
      )}
      {children}
    </div>
  );
};

export default EntryWrapper;
